export const WIDGET_DIMENSIONS = {
  ESTIMATED_HEIGHT: 200,
  MIN_HEIGHT: 180,
  CONTAINER_PADDING: 100,
  DEFAULT_GAP: 12,
  BOTTOM_MARGIN: 40,
} as const;
